import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialEstimateStatusesState = {};

const estimateStatusesSlice = createSlice({
  name: "estimateStatuses",
  initialState: initialEstimateStatusesState,
  reducers: {
    setEstimatesStatusesData: (_state: any, action: PayloadAction<any>) =>
      action.payload.reduce((prev: Record<string, any>, curr: any) => ({ ...prev, [curr.id]: curr }), {}),
  },
});

export const { setEstimatesStatusesData } = estimateStatusesSlice.actions;

export const estimateStatuses = estimateStatusesSlice.reducer;

export default estimateStatusesSlice.reducer;
